<template lang="pug">
  .sdo-chat-message.mx-2(
    :class=`[{
      'from-me' : message.fromMe,
      'from-them': !message.fromMe
    }, 'message-' + message.id]`
  )
    v-btn.mr-2(
      v-if="!message.fromMe"
      small
      fab
      outlined
      text
      dark
      :to=`!isReplyMessage ? null : {
        name: "StudentReview",
        params: { id: chat.replyTo.id },
      }`
    )
      v-icon(v-if="isReplyMessage") mdi-account-school
      span(v-else-if="!chat.hideInitials") {{ message.user_initials }}
      v-icon(v-else) mdi-account-tie
    .sdo-chat-message__content.secondary--text
      p.mb-1.pre-wrap {{ message.text }}
      .text-right.caption
        span {{ message.created_at | dp('HH:mm') }}
    tooltip-wrap(
      v-if="message.gpt_request && !message.gpt_request.is_processed && !message.fromMe"
      text="Нейросеть обработала сообщение. требуются действия"
    )
      v-btn(
        icon small color="warning" outlined
        :disabled="selectedProcessedMessage.id === message.id"
        @click="$emit('select')"
      ).ml-2
        v-icon mdi-information-slab-symbol
</template>

<script>
import anime from 'animejs';

export default {
  props: {
    // Instance of ChatMessage.js model
    message: { type: Object, required: true },
    selectedProcessedMessage: { type: Object, default: null },
  },
  inject: ['chat'],
  computed: {
    isReplyMessage() {
      return this.chat.replyTo && this.message.owner_id === this.chat.replyTo.id;
    },
  },
  mounted() {
    this.animateAppear();
  },
  methods: {
    animateAppear() {
      anime({
        targets: `.message-${this.message.id}`,
        translateX: [20, 0],
        opacity: [0, 1],
        duration: 600,
        autoplay: true,
        easing: 'easeOutExpo',
        delay: anime.stagger(20),
      });
    },
  },
};
</script>

<style lang="scss">
.sdo-chat-message {
  display: flex;
  max-width: 75%;
  margin: 0.5rem 0 0;

  &__content {
    position: relative;
    background: white;
    border-radius: 10px;
    padding: 0.5rem .875rem;
    word-wrap: break-word;

    &::before, &::after {
      content: "";
      bottom: -0.1rem;
      height: 1rem;
      position: absolute;
      z-index: -1;
    }

    &.no-tail::before {
      display: none;
    }
  }

  &.from-me ~ &.from-me {
    margin: 0.25rem 0 0;
  }

  &.from-me:first-child {
    .sdo-chat-message__content::before {
      display: none;
    }
  }

  &.from-me ~ &.from-me:not(:last-child) {
    .sdo-chat-message__content::before {
      display: none;
    }
  }

  &.from-me {
    align-self: flex-end;

    .sdo-chat-message__content {

      &::after {
        background-color: $secondary-color;
        border-bottom-left-radius: 0.5rem;
        right: -40px;
        transform:translate(-30px, -2px);
        width: 10px;
      }

      &::before {
        border-bottom-left-radius: 0;
        border-right: 1rem solid white;
        right: -0.35rem;
        transform: translate(0, -0.1rem);
      }
    }
  }

  &.from-them {
    display: flex;
    align-self: flex-start;
    align-items: flex-end;

    .sdo-chat-message__content {
      background: #eaecf5;

      &::after {
        border-bottom-right-radius: 0.5rem;
        background-color: $secondary-color;
        left: 20px;
        transform:translate(-30px, -2px);
        width: 10px;
      }

      &::before {
        border-bottom-right-radius: 0;
        border-left: 1rem solid #eaecf5;
        left: -.35rem;
        transform: translate(0, -0.1rem);
      }
    }
  }
}
</style>
